import { ChangeDetectorRef, Directive, ElementRef, inject, Input, NgZone } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';

import { DragDropConfig } from '../config/drag-drop-config';
import { DragDropSortableService } from '../service/drag-drop-sortable/drag-drop-sortable.service';
import { DragDropService } from '../service/drag-drop/drag-drop.service';
import type { SortableContainer } from '../sortable-container.model';
import { SortableArrayHandler } from '../util/sortable-array-handler';
import { SortableFormArrayHandler } from '../util/sortable-form-array-handler';
import { AbstractDirective } from './abstract/abstract.directive';

/* tslint:disable directive-selector */
@Directive({ standalone: false, selector: '[dnd-sortable-container]' })
export class SortableContainerDirective extends AbstractDirective implements SortableContainer {
  private sortableDataService = inject(DragDropSortableService);

  private _sortableData: any[] | UntypedFormArray;
  private _sortableHandler: SortableFormArrayHandler | SortableArrayHandler;

  @Input()
  set sortableData(sortableData: Array<any> | UntypedFormArray) {
    this._sortableData = sortableData;
    if (sortableData instanceof UntypedFormArray) {
      this._sortableHandler = new SortableFormArrayHandler();
    } else {
      this._sortableHandler = new SortableArrayHandler();
    }

    this.dropEnabled = !!this._sortableData;
  }

  get sortableData(): Array<any> | UntypedFormArray {
    return this._sortableData;
  }

  constructor() {
    const elementRef = inject(ElementRef);
    const dragDropService = inject(DragDropService);
    const config = inject(DragDropConfig);
    const cdr = inject(ChangeDetectorRef);
    const zone = inject(NgZone);

    super(elementRef, dragDropService, config, cdr, zone);
    this._sortableData = [];
    this.dragEnabled = false;
  }

  override dragEnterCallback(event: Event): void {
    if (this.sortableDataService.isDragged) {
      const item = this.sortableDataService.sortableContainer.getItemAt(this.sortableDataService.index);

      if (this.indexOf(item === -1)) {
        this.sortableDataService.sortableContainer.removeItemAt(this.sortableDataService.index);

        if (this.sortableDataService.sortableContainer.sortableData.length === 0) {
          this.sortableDataService.sortableContainer.dropEnabled = true;
        }

        this.insertItemAt(item, 0);
        this.sortableDataService.sortableContainer = this;
        this.sortableDataService.index = 0;
      }

      this.detectChanges();
    }
  }

  override dragEndCallback(event: Event): void {}

  override dragOverCallback(event: Event): void {}

  override dragLeaveCallback(event: Event): void {}

  getItemAt(index: number): any {
    return this._sortableHandler.getItemAt(this._sortableData, index);
  }

  indexOf(item: any): number {
    return this._sortableHandler.indexOf(this._sortableData, item);
  }

  removeItemAt(index: number): void {
    this._sortableHandler.removeItemAt(this._sortableData, index);
  }

  insertItemAt(item: any, index: number) {
    this._sortableHandler.insertItemAt(this._sortableData, item, index);
  }
}
